export enum TestApi {
    Execute = "NeoPref.Test Api.Execute",
}

export enum Investor {
    View = "NeoPref.Investor.View",
    Edit = "NeoPref.Investor.Edit",
    PreAuthorise = "NeoPref.Investor.Pre Authorise",
    Authorise = "NeoPref.Investor.Authorise",
}

export enum Issuer {
    View = "NeoPref.Issuer.View",
    Edit = "NeoPref.Issuer.Edit",
    PreAuthorise = "NeoPref.Issuer.Pre Authorise",
    Authorise = "NeoPref.Issuer.Authorise",
}

export enum IssuerInvestment {
    View = "NeoPref.Issuer Investment.View",
    Edit = "NeoPref.Issuer Investment.Edit",
    Authorise = "NeoPref.Issuer Investment.Authorise",
}

export enum Audit {
    View = "NeoPref.Audit.View",
}

export enum InvestorInvestment {
    View = "NeoPref.Investor Investment.View",
    Edit = "NeoPref.Investor Investment.Edit",
    Authorise = "NeoPref.Investor Investment.Authorise",
}

export enum DividendProcessing {
    View = "NeoPref.Dividend Processing.View",
    Process = "NeoPref.Dividend Processing.Process",
}

export enum Config {
    View = "NeoPref.Config.View",
    Edit = "NeoPref.Config.Edit",
    EditReporting = "NeoPref.Config.Edit Reporting",
    EditField = "NeoPref.Config.Edit Field",
}

export enum Contact {
    View = "NeoPref.Contact.View",
    Edit = "NeoPref.Contact.Edit",
    Delete = "NeoPref.Contact.Delete",
}

export enum LetterAuthorisation {
    View = "NeoPref.Letter Authorisation.View",
    Create = "NeoPref.Letter Authorisation.Create",
    Delete = "NeoPref.Letter Authorisation.Delete",
    AuthoriseWithoutSignatures = "NeoPref.Letter Authorisation.Authorise Without Signatures",
    AuthoriseLetter = "NeoPref.Letter Authorisation.Authorise Letter",
    ManageSignatories = "NeoPref.Letter Authorisation.Manage Signatories",
}

export enum PaymentExport {
    View = "NeoPref.Payment Export.View",
    Edit = "NeoPref.Payment Export.Edit",
    Export = "NeoPref.Payment Export.Export",
}

export enum System {
    IntegrityChecks = "NeoPref.System.Integrity Checks",
    SystemMaintenance = "NeoPref.System.System Maintenance",
    ViewLogs = "NeoPref.System.View Logs",
}

export enum User {
    View = "NeoPref.User.View",
}

export enum InvestorInvestmentApproval {
    View = "NeoPref.Investor Investment Approval.View",
    Edit = "NeoPref.Investor Investment Approval.Edit",
    Delete = "NeoPref.Investor Investment Approval.Delete",
}

export enum InternalApprover {
    View = "NeoPref.Internal Approver.View",
    Edit = "NeoPref.Internal Approver.Edit",
    Delete = "NeoPref.Internal Approver.Delete",
}

export enum ClientPortal {
    TermsAndConditions = "NeoPref.Client Portal.Terms And Conditions",
}

export enum PortalUsersAdmin {
    View = "NeoPref.Portal Users (Admin).View",
    Edit = "NeoPref.Portal Users (Admin).Edit",
    Delete = "NeoPref.Portal Users (Admin).Delete",
    Authorise = "NeoPref.Portal Users (Admin).Authorise",
}

export enum PortalUsersClient {
    View = "NeoPref.Portal Users (Client).View",
    Edit = "NeoPref.Portal Users (Client).Edit",
    Delete = "NeoPref.Portal Users (Client).Delete",
    Authorise = "NeoPref.Portal Users (Client).Authorise",
}